module.exports = __webpack_public_path__ + "static/media/galdinsLose_1000_2500.d6fc0537.png";